import { map, of } from 'rxjs'
import { filter, mergeMap, switchMap } from 'rxjs/operators'
import Actions from '../actions'
import { catchAndDispatchError, getPayload } from '../utils/rxUtils'
import apis from '../apis'
import { isOEP } from 'utils/generalUtils'

export const getAppConfig = action$ =>
  action$.pipe(
    getPayload(Actions.APP_LAUNCHED),
    switchMap(() => of(Actions.createAction(Actions.APP_CONFIG_REQUESTED)))
  )

export const getConfigurations = action$ =>
  action$.pipe(
    getPayload(Actions.APP_CONFIG_REQUESTED),
    switchMap(() => {
      return apis.getConfigurations().pipe(
        mergeMap(config => [
          Actions.createAction(Actions.APP_CONFIG_RECEIVED, {
            config
          })
        ]),
        catchAndDispatchError
      )
    })
  )

export const oepEpic = action$ =>
  action$.pipe(
    getPayload(Actions.APP_CONFIG_RECEIVED),
    filter(appConfig => isOEP(appConfig?.config)),
    map(appConfig => {
      return Actions.createAction(Actions.OEP_DETECTED, { appConfig })
    })
  )
